<div class="segment-bar" [class.outside]="isOutside" [ngClass]="color">
  <div class="segment-bar--wrapper">
    <i class="segment-bar--tick" *ngFor="let tick of ticks" [style.left]="tick"></i>
    <span class="segment-bar--bar" [style.width]="width"></span>
  </div>
</div>
